import type MetaInterface from '@/interfaces/MetaInterface';
  
  // This file is auto-generated by the build system.
  const meta: MetaInterface = {
    version: '1.0.2',
    date: '2026-06-16T10:02:32.978Z',
  };
  export default meta;
  